import ServiceExec from '@/common/utils/ServiceExec';
import { announcement } from '@/common/service/apiList';
import { asFormData, churchCityLetterCut, fileRequestBinding, isEmpty, REMOVE_EMPTY_PARAMS } from '@/common/utils/Util';
import { cloneDeep } from 'lodash';
import store from '@/store';
import dayjs from 'dayjs';
import { showTextModal } from '@/common/utils/ModalState';

export default {
  async save({ commit, getters, state }, payload) {
    let reqParams = cloneDeep(payload);
    funeralFormat(reqParams);
    fileRequestBinding(reqParams, 'rawFile');
    reqParams = asFormData(reqParams);
    const { status, data } = await ServiceExec.multiPost(announcement.save, reqParams);

    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  /**
   * 부고장 리스트 조회
   */
  async getAnnouncementList({ commit, state }) {
    const reqData = cloneDeep(state.condition);
    if (reqData.page > state.pageInfo.endPage) return;
    const { userNo } = store.getters['user/getUserData'];
    reqData.userNo = userNo;
    const { data, status } = await ServiceExec.get(announcement.getAnnouncementList, {
      ...REMOVE_EMPTY_PARAMS(reqData)
    });
    if (status !== ServiceExec.status.OK) return false;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    reqData.page = reqData.page + 1;
    commit('setCondition', reqData);
    commit('setPageInfo', pageInfo);
    commit('setList', list ?? []);
  },

  /**
   * 부고장 상세
   */
  async getDetail({ commit, getters, state }, funeralNo) {
    const { data, status } = await ServiceExec.get(announcement.getAnnouncement(funeralNo));
    if (status !== ServiceExec.status.OK) return false;
    commit('setDetail', data ?? '');
  },

  async remove({ commit, getters, state }, announcementNo) {
    const { status } = await ServiceExec.patch(announcement.remove(announcementNo));
    return status === ServiceExec.status.OK;
  },

  /**
   * 온라인 부고장 수정
   * @param payload
   * @return {Promise<boolean>}
   */
  async update({ commit, getters, state }, payload) {
    let reqParams = cloneDeep(payload);
    funeralFormat(reqParams);
    const { status, data } = await ServiceExec.multiPut(
      announcement.update,
      asFormData(REMOVE_EMPTY_PARAMS(reqParams))
    );

    if (status === ServiceExec.status.OK) return data;
    return false;
  },

  async download({ commit, getters, state }, payload) {
    const request = {};
    request.startDate = dayjs(payload.carryDate)
      .subtract(30, 'days')
      .format('YYYY-MM-DD');
    request.endDate = dayjs(payload.carryDate).format('YYYY-MM-DD');
    request.searchText = payload.announcementNo;

    const { data, status } = await ServiceExec.get(announcement.download, request);
    console.log('download data', data);
    return ServiceExec.status.OK === status;
  }
};

const funeralFormat = reqParams => {
  const { userNo, familyCode, churchNo } = store.getters['user/getUserData'];
  reqParams.userNo = userNo;
  reqParams.familyCode = familyCode;
  reqParams.churchNo = churchNo;
  reqParams.churchName = churchCityLetterCut(reqParams.churchName);
  reqParams.family = JSON.stringify(reqParams.family);
  // reqParams.casketDate = convertToLocalDateTime(reqParams.casketDate);
  // reqParams.carryDate = convertToLocalDateTime(reqParams.carryDate);
};
